import script from "./IndexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=cbb652a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbb652a8"]])

export default __exports__